module.exports = __webpack_public_path__ + "media/images/top-page_illustration-step2-5eeddaced6c0a060737b137796335695.svg";